@if (landingpageConfig(); as _landingpageConfig) {
  <ez-main-layout [landingpageConfig]="_landingpageConfig" [theme]="Themes.NONE">
    <ez-banner>
      <span ngProjectAs="title">
        {{ _landingpageConfig.organisation.customFields['title'] || 'Ihr Versicherungs&shy;beitrag' }}
      </span>
      <span ngProjectAs="subtitle">
        {{ _landingpageConfig.organisation.customFields['subtitle'] || 'Jetzt unkompliziert bezahlen' }}
      </span>
    </ez-banner>

    <p style="margin-top: 0">
      {{ _landingpageConfig.organisation.customFields['customerNumberLabel'] || 'Kundennummer' }}:
      {{ _landingpageConfig.customer.customerNumber }}
    </p>

    <h3>
      @if (isPrivateCustomer(_landingpageConfig.customer)) {
        Guten Tag, {{ _landingpageConfig.customer.salutation }} {{ _landingpageConfig.customer.title }}
        {{ _landingpageConfig.customer.firstName }} {{ _landingpageConfig.customer.lastName }},
      } @else {
        Sehr geehrte Damen und Herren,
      }
    </h3>

    <p
      [innerHTML]="
        _landingpageConfig.organisation.customFields['introduction'] ||
        'den offenen Beitrag können Sie hier direkt und unkompliziert zahlen.<br/> Wählen Sie dazu eine Zahlungsmethode aus. <br/><br/> Dann drücken Sie auf den \'Jetzt&nbsp;Bezahlen\' Button.'
      "
    ></p>

    <h3>{{ _landingpageConfig.organisation.customFields['subheading'] || 'Jetzt einfach und sicher zahlen' }}</h3>

    <ez-payment-details
      [organisation]="_landingpageConfig.organisation"
      [totalAmount]="_landingpageConfig.totalAmount"
      [contracts]="_landingpageConfig.contracts"
    ></ez-payment-details>

    <ez-payment-method-selection
      [paymentMethods]="paymentMethods()"
      (chosePaymentMethod)="chosePaymentMethod($event)"
    ></ez-payment-method-selection>

    @if (hasManualPayment(_landingpageConfig.paymentConfiguration)) {
      <ez-manual-payment
        [organisation]="_landingpageConfig.organisation"
        [manualPaymentConfiguration]="_landingpageConfig.paymentConfiguration.manualPaymentConfiguration"
        [reasonForPayment]="_landingpageConfig.reasonForPayment"
      ></ez-manual-payment>
    }

    <ez-contact
      [organisation]="_landingpageConfig.organisation"
      [customData]="_landingpageConfig.customData"
      teaser="{{
        _landingpageConfig.organisation.customFields['contactTeaser'] ||
          'Sie haben schon gezahlt oder möchten noch Fragen mit uns klären? Sie können nur einen Teil des Beitrags zahlen? <br> <br> Dann rufen Sie uns bitte an:'
      }}"
      subtitle="{{ _landingpageConfig.organisation.customFields['contactSubtitle'] }}"
      phonePrefix="{{ _landingpageConfig.organisation.customFields['contactPhonePrefix'] || 'Kundenservice: ' }}"
      withContactForm="false"
    ></ez-contact>
  </ez-main-layout>
}
